import { actionCreator } from '@ardoq/rxbeach';
import type { TourId } from '@ardoq/product-tours';

export const startTour = actionCreator<TourId>('[productTour] START_TOUR');

export type StartTourAtStepPayload = {
  tourId: TourId;
  stepIndex: number;
};

export const startTourAtStep = actionCreator<StartTourAtStepPayload>(
  '[productTour] START_TOUR_AT_STEP'
);

export const nextTourStep = actionCreator('[productTour] NEXT_STEP');

export const prevTourStep = actionCreator('[productTour] PREV_STEP');

export const endTour = actionCreator('[productTour] END_TOUR');
